import styles from "./WaiterAvatar.module.scss";

interface WaiterAvatarProps {
  name: string;
  /** Their photo. Absent until the staff endpoint carries one. */
  photoUrl?: string;
  /** "tile" for the picker grid, "large" for the tip screen itself. */
  size?: "tile" | "large";
}

/**
 * A waiter's round photo, or their initial when there is none.
 *
 * The fallback is a letter rather than a generic person icon: with a whole
 * grid of them, one silhouette repeated eight times tells the guest nothing,
 * while the initial at least pairs with the name underneath.
 */
function WaiterAvatar(props: WaiterAvatarProps) {
  const { name, photoUrl, size = "tile" } = props;
  const initial = name.trim().charAt(0).toUpperCase();

  return (
    <div
      className={`${styles.waiterAvatar} ${
        size === "large" ? styles.waiterAvatarLarge : ""
      }`}
    >
      {photoUrl ? (
        <img src={photoUrl} alt="" className={styles.waiterAvatarImage} />
      ) : (
        <p className={`title-large ${styles.waiterAvatarInitial}`}>{initial}</p>
      )}
    </div>
  );
}

export default WaiterAvatar;
